import React, { useState } from 'react';
import { MenuIcon, XIcon, GlobeIcon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Nav() {
  const [open, setOpen] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  const links = [{
    href: '#inicio',
    label: t('nav.inicio')
  }, {
    href: '#servicios',
    label: t('nav.servicios')
  }, {
    href: '#contacto',
    label: t('nav.contacto')
  }, {
    href: '#repertorio',
    label: t('nav.repertorio')
  }, {
    href: '#shows',
    label: t('nav.shows')
  }];
  const toggleLang = () => setLang(lang === 'es' ? 'en' : 'es');
  return <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-ink/70 border-b border-gold/10" data-id="element-122">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between gap-4" data-id="element-123">
        <a href="#inicio" className="font-display text-2xl tracking-[0.2em] gold-text" data-id="element-124">
          JADE
        </a>

        <nav className="hidden md:flex items-center gap-8" data-id="element-125">
          {links.map(l => <a key={l.href} href={l.href} className="text-sm text-cream/80 hover:text-gold transition-colors" data-id="element-126">
              {l.label}
            </a>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-127">
          <button onClick={toggleLang} aria-label="Toggle language" className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-gold/30 text-cream/80 hover:text-gold hover:border-gold transition-colors text-xs tracking-wider" data-id="element-128">
            <GlobeIcon size={13} data-id="element-129" />
            {lang === 'es' ? 'EN' : 'ES'}
          </button>
          <a href="#contacto" className="hidden md:inline-flex items-center px-5 py-2 rounded-full bg-gold text-ink font-medium text-sm hover:bg-gold-light transition-colors" data-id="element-130">
            {t('nav.reservar')}
          </a>
          <button className="md:hidden text-cream" onClick={() => setOpen(!open)} aria-label="Menu" data-id="element-131">
            {open ? <XIcon size={22} data-id="element-132" /> : <MenuIcon size={22} data-id="element-133" />}
          </button>
        </div>
      </div>

      {open && <div className="md:hidden border-t border-gold/10 bg-ink px-6 py-4 flex flex-col gap-4" data-id="element-134">
          {links.map(l => <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-cream/80 hover:text-gold" data-id="element-135">
              {l.label}
            </a>)}
          <a href="#contacto" onClick={() => setOpen(false)} className="px-5 py-2 rounded-full bg-gold text-ink font-medium text-center" data-id="element-136">
            {t('nav.reservar')}
          </a>
        </div>}
    </header>;
}